// A [data-notice-dismiss] button fades its [data-notice] card out, then
// removes it and hands focus to the element its value names, so a
// keyboard user keeps their place instead of landing on <body>. The fade
// runs through the Web Animations API because the card's entry
// animation holds its opacity, which an inline style cannot override.
let dismissReady = false;

export function initNoticeDismiss() {
  if (dismissReady) return;
  dismissReady = true;

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-notice-dismiss]");
    const card = button?.closest("[data-notice]");
    if (!card) return;

    const next = document.querySelector(button.dataset.noticeDismiss);
    const still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    card.getAnimations().forEach((animation) => animation.cancel());
    card
      .animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: still ? 0 : 150,
        easing: "cubic-bezier(0.23, 1, 0.32, 1)",
        fill: "forwards",
      })
      .finished.then(() => {
        next?.focus({ preventScroll: true });
        card.remove();
      });
  });
}
